/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '/profile',
    name: '書いてる人',
    view: 'Profile'
  },
  {
    path: '/works',
    name: '作ったもの',
    view: 'Works'
  },
  {
    path: '/blog',
    // Relative to /src/views
    name: 'ブログとか',
    view: 'Blog'
  },
  {
    path: '/slide',
    name: 'スライド',
    view: 'Slide'
  },
  {
    path: '/table-list',
    name: 'Table List',
    view: 'TableList'
  },
  {
    path: '/maps',
    view: 'Maps'
  },
  {
    path: '/skill',
    name: 'スキル',
    view: 'Skill'
  }
]
